
import { getData, postData, putData, deleteData } from "../apiClient";

// Get Gallery Imagess with pagination
export const getGalleryImages = async ({ page = 1, limit = 10, search = "" }, signal = null) => {
  try {
    const queryParams = new URLSearchParams({
      page: String(page),
      limit: String(limit),
      search: search,
    });

    const result = await getData(`/gallery/?${queryParams}`, {}, {}, signal);
    return {
      success: true,
      ...result,
    };
  } catch (error) {
    console.error("Get Gallery Images with pagination API error:", error);
    return {
      success: false,
      ...error,
    };
  }
};

// Get Gallery Images data with id
export const getGalleryImage = async (id) => {
  try {
    const result = await getData(`/gallery/${id}`);
    return {
      data: {
        success: true,
        ...result,
      },
    };
  } catch (error) {
    console.error("Get Gallery Images data API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// create user ** // Updated Api Error Handle Method
export const createGalleryImage = async ({ data }) => {
  try {
    const result = await postData(`/gallery/`, data, { "Content-Type": "multipart/form-data" });
    
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Gallery Images API error:", error.status === 400 ? error.error : error.message);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};

// delete user
export const deleteGalleryImage = async ({ id }) => {
  try {
    const result = await deleteData(`/gallery/${id}`);
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Delete Gallery Images API error:", error);
    return {
      data: {
        success: false,
        error: error.message,
      },
    };
  }
};

// update user data
export const updateGalleryImage = async ({id, data }) => {
  try {
    const result = await putData(`/gallery/${id}`, data, { "Content-Type": "multipart/form-data" });
    return {
      data: {
        success: true,
        data: result,
      },
    };
  } catch (error) {
    console.error("Update Gallery Images API error:", error);
    return {
      data: {
        success: false,
        error: error.status === 400 ? error.error : error.message,
        status: error.status,
      },
    };
  }
};
